export default {"src":"/_next/static/media/circleCheckmarkGreen_24.5f73a910.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};